import React from 'react';
import { MoreHorizontal } from 'react-feather';

import UserItem from '../UserItem';
import './style.css';

function FollowingArea() {

    return (
        <aside className="following">
            <div className="following-top">
                <h1>Seguindo</h1>
                <MoreHorizontal />
            </div>
            <div className="following-list">
                <ul>
                    <li>
                        <UserItem
                            id={1}
                            image=""
                            alt="Lucia Campos"
                            name="Lucia Campos"
                        />
                    </li>

                    <li>
                        <UserItem
                            id={1}
                            image=""
                            alt="João Silva"
                            name="João Silva"
                        />
                    </li>
                </ul>
            </div>
        </aside>
    )
}

export default FollowingArea; 